<footer class="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
  <p class="text-muted mb-1 mb-md-0">Copyright © {{ today | date:'y'}} <a href="https://ianos.app" target="_blank">IanOS</a>.</p>
  <p class="text-muted"> v23.6.28 </p>
</footer>
